import { gql } from '@apollo/client';

const INITIALIZE_PRODUCT_DOWNLOAD = gql`
  mutation InitializeProductDownload($productId: ID!) {
    initProductDownload(productId: $productId)
  }
`;

export default INITIALIZE_PRODUCT_DOWNLOAD;
